<template>
  <div class="slide">
  <div class="grid-container grid-container--small mb--2rem">
      <div class="grid-x js--insertMobileTooltip">
        <div class="small-12 cell   of--visible">
    
      <h2>Marker hvilke dager du drikker</h2>
      <div class="mt-3">
      <p>Oppgi hvor mange ganger du drikker MYE og MODERAT på en måned.</p>
      </div>
      </div>
    </div>
 </div>
    <div class="grid-container grid-container--small ">
      <div class="grid-x max">
          <div class=" small-12 cell">
            <div class="dayNames">
              <div class="dayName"><span class="hide-mobile">mandag</span><span class="hide-desktop">m</span></div>
              <div class="dayName"><span class="hide-mobile">tirsdag</span><span class="hide-desktop">t</span></div>
              <div class="dayName"><span class="hide-mobile">onsdag</span><span class="hide-desktop">o</span></div>
              <div class="dayName"><span class="hide-mobile">torsdag</span><span class="hide-desktop">t</span></div>
              <div class="dayName"><span class="hide-mobile">fredag</span><span class="hide-desktop">f</span></div>
              <div class="dayName"><span class="hide-mobile">lørdag</span><span class="hide-desktop">l</span></div>
              <div class="dayName"><span class="hide-mobile">søndag</span><span class="hide-desktop">s</span></div>
            </div>
            <div class="calendar">
            
    <div
        class="calendarDay"
        :class="{weekend: day.weekend}"
        v-for="(day, i) in calendar"
        :key="i"
        @click="openModal(day)"
      >
        <div class="day" :class="{much: (day.alcohol==2), normal: (day.alcohol==1)}">
            <small>{{ day.number }}</small>
            <em v-if="day.alcohol==1">
            <span class="icon drinkend standingbottles fill"></span>
            Moderat
            </em>
            <em  v-else-if="day.alcohol==2">
            <span class="icon drinkstart standingandlyingbottle fill"></span>
            Mye
            </em>
            <p v-else>Velg </p>
            
            <p class="hide-desktop" v-if="day.alcohol==1">
              Moderat
            </p>
            <p class="hide-desktop" v-else-if="day.alcohol==2">
              Mye
            </p>

        </div>
    </div>
    <div style="clear:both; overflow:auto;"></div>
      </div>
          </div>
    </div>
    <div class="notmuch">
    <input type="checkbox" value="1" v-model="notmuch" id="notmuch"/>
    <label for="notmuch">
    
    Jeg drikker ikke mye hver måned
    </label>
    </div>
    
    
      <!-- use the modal component, pass in the prop -->
    <modal v-if="showModal" @close="showModal = false" :item="modalDay">
  </div>
</template>

<script>
import Modal from "../common/Modal";

export default {
  components: {
    Modal: Modal,
  },

  mounted() {
    if (this.init == false) {
      this.init = true;
      if (typeof this.calendar === "undefined" || this.calendar.length == 0) {
        for (let i = 1; i < 29; i++) {
          let weekend = (i%7 == 6 || i%7 == 0)
          this.calendar.push({number:i, alcohol : 0, weekend: weekend})
        }
      }
    }
  },
  data() {
    return {
      showModal: false,
      modalDay: null,
      init: false,
      notmuch: 0,
    };
  },
  
  methods:{
    openModal(item) {
      this.showModal = true;
      this.modalDay = item;
    },
    toggleDay(item) {
      item.alcohol++;
      if(item.alcohol>2){
          item.alcohol=0;
      }
      
    },
    littleAlco(){
        return this.calendar.filter((day) => day.alcohol == 1);
    },
    lotsAlco(){
        return this.calendar.filter((day) => day.alcohol == 2);
    },
    
  },
  computed: {
    calendar: {
      get() {
        return this.$store.state.calendar;
      },
      set(value) {
        this.$store.commit("setCalendar", { calendar: value });
      },
    },
  },
};
</script>

<style lang="scss">
.dayNames, .calendar{
  margin:0 1px;
max-width:760px;
}
.dayName, .calendarDay{
    width:14.285714285%; float:left; display:inline-block;
  position:static;
  z-index:unset
}
.dayName{
  text-align:center;
  padding-bottom:10px;
}
.calendarDay .day{
    border:2px solid #083650; padding:1rem; display:block; margin:0;
    height:100px;
    background:#f9efe7;
    margin:-2px 0 0 -2px;
    position:relative;
    
    p{
      line-height:100px;
      text-align: center;
      display:block;
      width:100%;
      font-style:normal;
    }
    
    padding:0;
    cursor:pointer;
    
    z-index:1;
    &:hover{
      transform: scale(1.08);
      z-index:2;
      background-color:#E9E3DC;
    }
    small{
      position:absolute;
      top:10px;
      right:10px;
    }
    em{
      text-align: center;
      font-style:normal;
      display:block;
      padding-top:10px;
      
    }
    
    @media screen and (max-width:639px){
      em{
        display:none;
      }
      p.hide-desktop{
        padding:0;
      }
      }
    @media screen and (min-width:640px){
      p.hide-desktop{display:none}
    }

    @media screen and (max-width:780px){
      height:90px;
      p{line-height:90px;}
    }
    @media screen and (max-width:639px){
      height:80px;
      p{line-height:80px;}
    }
    @media screen and (max-width:540px){
      height:70px;
      p{line-height:70px;}
    }
    @media screen and (max-width:480px){
      
      height:60px;
      p{line-height:60px;}
      small{
        top:4px;
        right:4px;
        font-size:12px;
      }
    }
    @media screen and (max-width:360px){
      height:50px;
      p{line-height:50px;}
    }
    
}
.calendarDay.weekend {
  
  .day{
      background:#fae8e0
    }
    &:hover .day{
      background-color:#E9E3DC;
    }
}
  .calendarDay .day.much{
    background:#8D90C6
  }
  .calendarDay .day.normal{
    background:#FFE4AA
  }
    .notmuch{
      padding:1rem 0 1rem 0rem;
      label{
        padding-left:2rem;
        margin-left:0;
        position:relative;
        &:before{
          position:absolute;
          content:"";
          width:20px;
          height:20px;
          left:0;
          top:3px;
          border-radius:50%;
          border:2px solid #083650;
        }
      }
      
      input[type="checkbox"] {
        display:none;
      }
      
      input[type="checkbox"]:checked + label{
        &:after{
          position:absolute;
          content:"";
          width:12px;
          height:12px;
          left:4px;
          top:7px;
          background:#083650;
          border-radius:50%;
        }
      }
    }

    .icon.fill{
      
      max-width:45%;
      padding-bottom:43%;
      margin: 0 auto;
      text-align: center;
      display: block;
    }
    
</style>
